class FileUploadModalController {
  constructor($window) {
    'ngInject';
    this.$window = $window;
    this.keyDownEvent = event => this.keyDown({event});
  }
  
  $onInit() {
    this.$window.addEventListener("keydown", this.keyDownEvent);
  }
  
  $onDestroy() {
    this.$window.removeEventListener("keydown", this.keyDownEvent);
  }

  openFile(event) {
    event.preventDefault();
    this.$window.open(this.fileUrl, '_blank');
  }

}

export default {
  templateUrl: 'fe-control/modals/file-upload/file-upload.component.html',
  bindings:{
    'model': '=?',
    'fieldId': '<?',
    'modalTitle': '<?',
    'onFileRead': '&?',
    'cancelModal': "&?",
    'providerFile': '=?',
    'file': '=?',
    'fileUrl': '=?',
    'doneModal': '&?',
    'clearModal': '&?',
    'copy': "<?",
    'formatString': '=',
    'fieldDimensions': "<?",
    'pageDimensions': "<?",
    'originalSize': "<?",
    'keyDown': '&?'
  },
  controller: FileUploadModalController
}
